import { RootState } from 'types/state'

export const SET_STUDIO_HAS_HIGHLIGHTS = 'SET_STUDIO_HAS_HIGHLIGHTS'
export const SET_STUDIO_PROFILE_STATE = 'SET_STUDIO_PROFILE_STATE'
export const SET_NEW_PANEL_TYPE_SELECTED = 'SET_NEW_PANEL_TYPE_SELECTED'
export const SET_WEBGL_SUPPORTED = 'SET_WEBGL_SUPPORTED'

export const setStudioHasHighlights = (value: boolean) => ({
  type: SET_STUDIO_HAS_HIGHLIGHTS,
  payload: value,
})
export const setStudioProfileState = (value: StudioProfileState) => ({
  type: SET_STUDIO_PROFILE_STATE,
  payload: value,
})
export const setNewPanelTypeSelected = (isSelected: boolean) => ({
  type: SET_NEW_PANEL_TYPE_SELECTED,
  payload: isSelected,
})
export const setWebGLSupport = (value: boolean) => ({
  type: SET_WEBGL_SUPPORTED,
  payload: value,
})

const defaultState: StudioState = {
  hasHighlightsRow: false,
  studioProfileState: 'not-loaded',
  isNewPanelTypeJustSelected: false,
  webGLSupport: true,
}

export default function reducer(previousState = defaultState, { type, payload }: { type: string; payload: any }) {
  if (type === SET_STUDIO_HAS_HIGHLIGHTS) {
    return {
      ...previousState,
      hasHighlightsRow: !!payload,
    }
  } else if (type === SET_STUDIO_PROFILE_STATE) {
    return {
      ...previousState,
      studioProfileState: payload,
    }
  } else if (type === SET_NEW_PANEL_TYPE_SELECTED) {
    return {
      ...previousState,
      isNewPanelTypeJustSelected: payload,
    }
  } else if (type === SET_WEBGL_SUPPORTED) {
    return {
      ...previousState,
      webGLSupport: payload,
    }
  }
  return previousState
}

export const studioSelectors = {
  getStudioProfileState: (state: RootState) => {
    return state.studio.studioProfileState
  },
  getIsNewPanelTypeJustSelected: (state: RootState) => {
    return state.studio.isNewPanelTypeJustSelected
  },
  getWebGLSupport: (state: RootState) => {
    return state.studio.webGLSupport
  },
}

export type StudioState = {
  hasHighlightsRow: boolean
  studioProfileState: StudioProfileState
  isNewPanelTypeJustSelected: boolean
  webGLSupport: boolean
}

export type StudioProfileState = 'not-loaded' | 'loading' | 'loaded'
